/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { RentalCarRepairShopPricing } from '../models';
// @ts-ignore
import { TextTemplate } from '../models';
// @ts-ignore
import { TextTemplatesRenderTextTemplateKeyGet200Response } from '../models';
/**
 * TextTemplatesApi - axios parameter creator
 * @export
 */
export const TextTemplatesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all text templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/text_templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get text template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('textTemplatesIdGet', 'id', id)
            const localVarPath = `/text_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update text_templates
         * @param {number} id 
         * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesIdPut: async (id: number, rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('textTemplatesIdPut', 'id', id)
            const localVarPath = `/text_templates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rentalCarRepairShopPricing, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Render a text template
         * @param {number} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesRenderTextTemplateKeyGet: async (key: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('textTemplatesRenderTextTemplateKeyGet', 'key', key)
            const localVarPath = `/text_templates/render_text_template/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TextTemplatesApi - functional programming interface
 * @export
 */
export const TextTemplatesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TextTemplatesApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all text templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async textTemplatesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TextTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.textTemplatesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get text template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async textTemplatesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.textTemplatesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update text_templates
         * @param {number} id 
         * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async textTemplatesIdPut(id: number, rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RentalCarRepairShopPricing>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.textTemplatesIdPut(id, rentalCarRepairShopPricing, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Render a text template
         * @param {number} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async textTemplatesRenderTextTemplateKeyGet(key: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TextTemplatesRenderTextTemplateKeyGet200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.textTemplatesRenderTextTemplateKeyGet(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TextTemplatesApi - factory interface
 * @export
 */
export const TextTemplatesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TextTemplatesApiFp(configuration)
    return {
        /**
         * Get all text templates
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesGet(options?: any): AxiosPromise<Array<TextTemplate>> {
            return localVarFp.textTemplatesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get text template
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesIdGet(id: number, options?: any): AxiosPromise<TextTemplate> {
            return localVarFp.textTemplatesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update text_templates
         * @param {number} id 
         * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesIdPut(id: number, rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options?: any): AxiosPromise<RentalCarRepairShopPricing> {
            return localVarFp.textTemplatesIdPut(id, rentalCarRepairShopPricing, options).then((request) => request(axios, basePath));
        },
        /**
         * Render a text template
         * @param {number} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        textTemplatesRenderTextTemplateKeyGet(key: number, options?: any): AxiosPromise<TextTemplatesRenderTextTemplateKeyGet200Response> {
            return localVarFp.textTemplatesRenderTextTemplateKeyGet(key, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TextTemplatesApi - object-oriented interface
 * @export
 * @class TextTemplatesApi
 * @extends {BaseAPI}
 */
export class TextTemplatesApi extends BaseAPI {
    /**
     * Get all text templates
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextTemplatesApi
     */
    public textTemplatesGet(options?: AxiosRequestConfig) {
        return TextTemplatesApiFp(this.configuration).textTemplatesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get text template
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextTemplatesApi
     */
    public textTemplatesIdGet(id: number, options?: AxiosRequestConfig) {
        return TextTemplatesApiFp(this.configuration).textTemplatesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update text_templates
     * @param {number} id 
     * @param {RentalCarRepairShopPricing} [rentalCarRepairShopPricing] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextTemplatesApi
     */
    public textTemplatesIdPut(id: number, rentalCarRepairShopPricing?: RentalCarRepairShopPricing, options?: AxiosRequestConfig) {
        return TextTemplatesApiFp(this.configuration).textTemplatesIdPut(id, rentalCarRepairShopPricing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Render a text template
     * @param {number} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TextTemplatesApi
     */
    public textTemplatesRenderTextTemplateKeyGet(key: number, options?: AxiosRequestConfig) {
        return TextTemplatesApiFp(this.configuration).textTemplatesRenderTextTemplateKeyGet(key, options).then((request) => request(this.axios, this.basePath));
    }
}
